import { nextIdlePeriod } from '@tdp/common/shared';

import { DevPortalRoot } from '../compositionRoot';
import { clientPreferenceStartup } from './clientPreference';
import { attachDevPortalConsoleTools } from './developmentTools';
import { loginStartup } from './login';
import { tdpSettingsStartup } from './tdpSettings';
import { themeStartup } from './theme';
import { BuildConfig } from '../util/buildConfig';

export type StartupFunction = (root: DevPortalRoot, buildConfig: BuildConfig) => Promise<void> | void;

//TODO(nibeauli): determine if this needs a 'registration' function or if we can just hard-code this.
const startupFunctions: StartupFunction[] = [
  loginStartup,
  attachDevPortalConsoleTools,
  // TODO(nibeauli): These all (should) synchronously fire commands that will be handled after interactive.
  // this should probably be a separate function that makes this pattern of firing commands on startup cleaner.
  clientPreferenceStartup,
  themeStartup,
  tdpSettingsStartup,
];

/**
 * This is the final set of operations to perform before displaying the application to the user. 
 * 
 * Once this function resolves, the application is displayed to the user and interactive.
 * 
 * The total runtime of the function should be minimal as this is the perceieved startup time.
 * @param root 
 * @param buildConfig 
 */
export async function startup(root: DevPortalRoot, buildConfig: BuildConfig) {
  await nextIdlePeriod();
  const logger = root.services.logger.extend('startup');
  for (const startupFunction of startupFunctions) {
    const start = performance.now();
    await startupFunction(root, buildConfig);
    const end = performance.now();
    const duration = end - start;
    const functionName = startupFunction.name;

    logger.log('Startup function "%s" took %dms to execute.', functionName, duration);
  }
}
